import React from 'react';
import './OutliersTitlePanel.scss';
import { useOutliersConfigSlice } from 'widgets/outliers/store/config/configSlice';
import {
    OutliersConfigState,
    plTypeText,
} from 'widgets/outliers/store/config/OutliersConfigState';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { useSelectLocked } from 'layoutRenderer/store/selectors';

export function OutliersTitlePanel() {
    const { config, dispatchConfigChanged } = useOutliersConfigSlice();
    const isLocked = useSelectLocked();

    const { plType, benchmarkType, hideTitlePanel } = config;

    if (hideTitlePanel) {
        return <></>;
    }
    const title = `${plTypeText(plType)} P&L Benchmarked to ${
        benchmarkType === 'arrivalPrice'
            ? 'Arrival Price'
            : 'Adjusted Arrival Price'
    }`;

    const handleCloseClick = () => {
        const delta: Partial<OutliersConfigState> = {
            hideTitlePanel: true,
        };
        dispatchConfigChanged(delta);
    };

    return (
        <div className="OutliersTitlePanel">
            <div>
                <div>{title}</div>
                {!isLocked && <Icon name="close" onClick={handleCloseClick} />}
            </div>
        </div>
    );
}
